import DemoMeeting from "@/pages/DemoMeeting";

export default function DemoMeetingV1() {
  return (
    <div className="demo-v1-theme v1-noise">
      <DemoMeeting />
    </div>
  );
}
